import React, { useRef, useState } from 'react';

import { SelectValidator } from 'react-material-ui-form-validator';
import {
  Grid,
  Paper,
  Button,
  makeStyles,
  Chip,
  Typography,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from '@material-ui/core';

import { getValidations } from '../../../helpers/validations/getValidations';
import Buscador from '../../../actions/ui/Buscador';

const buttonStyle = {
  textAlign: 'center',
};

const useStyles = makeStyles((theme) => ({
  chip: {
    margin: theme.spacing(0.5),
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: '0.5em 0 0',
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
  },
}));

export const SelectValidatorGeneric = ({
  value,
  name,
  label,
  fullWidth = true,
  variant = 'outlined',
  onChange,
  inputLabelProps = { style: { fontWeight: 'bold' } },
  validations = [],
  menuItems = [],
  ...props
}) => {
  const { validators, errorMessages } = validations
    ? getValidations(validations)
    : [];

  return (
    <SelectValidator
      {...props}
      variant={variant}
      fullWidth={fullWidth}
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      inputlabelprops={{ style: { fontWeight: 'bold' } }}
      validators={validators}
      errorMessages={errorMessages}
    >
      {menuItems.map((item, index) => (
        <MenuItem key={index} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </SelectValidator>
  );
};

export const SelectGeneric = ({
  value,
  name,
  label,
  fullWidth = true,
  variant = 'outlined',
  onChange,
  inputLabelProps = { style: { fontWeight: 'bold' } },
  menuItems = [],
  ...props
}) => {
  return (
    <>
      <InputLabel id={label} style={{ textAlign: "left" }}>{label}</InputLabel>
      <Select
        {...props}
        variant={variant}
        fullWidth={fullWidth}
        // label={label}
        name={name}
        value={value}
        onChange={onChange}
        inputlabelprops={{ style: { fontWeight: 'bold' } }}
      >
        {menuItems.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export const GSelect = ({
  value,
  name,
  label,
  fullWidth = true,
  variant = 'outlined',
  onChange,
  menuItems = [],
  ...props
}) => {
  const classes = useStyles();
  const [selectValue, setSelectValue] = useState(value);
  return (
    <FormControl className={classes.formControl}>
      <InputLabel id={label} style={{ left: '1em', fontSize: '1em' }}>
        {label}
      </InputLabel>
      <Select
        {...props}
        id={label}
        variant={variant}
        fullWidth={fullWidth}
        name={name}
        value={selectValue}
        onChange={(e) => {
          setSelectValue(e.target.value);
          onChange(e);
        }}
      >
        {menuItems.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const MultiSelectValidatorGeneric = ({
  selectList,
  formList,
  setearValorForm,
  deleteValorForm,
  titleChip,
  chipLabel,
  noChip,
  selectProps,
}) => {
  const classes = useStyles();

  const [value, setValue] = useState(null);
  const [list, setList] = useState(
    selectList.filter(
      (item) =>
        formList.length === 0 ||
        !formList.some((formItem) => formItem.id === item.value),
    ),
  );

  const insertValue = () => {
    const data = { id: value.value, descripcion: value.label };
    setList(list.filter((item) => item.value !== data.id));
    setearValorForm([...formList, data]);
    setValue(null);
  };

  return (
    <Grid
      container
      spacing={1}
      style={{ padding: '1em' }}
      component={Paper}
      elevation={2}
      justify="center"
      alignItems="center"
    >
      <Grid item xs={12}>
        <Paper elevation={2} style={{ padding: '1em' }}>
          <Grid container direction="column" spacing={2}>
            <Grid item xs={12}>
              <SelectValidatorGeneric
                value={value?.value}
                onChange={(e) => {
                  setValue(list.find((item) => item.value === e.target.value));
                }}
                menuItems={list}
                {...selectProps}
              />
            </Grid>
            <Grid item xs={12} style={buttonStyle}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={insertValue}
                disabled={!value}
              >
                + AGREGAR
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          marginTop: '1em',
        }}
      >
        <Typography variant="button">{titleChip}</Typography>
        <div className={classes.root}>
          {formList.length > 0 ? (
            formList.map((item, index) => (
              <Chip
                key={index}
                label={chipLabel(item)}
                onDelete={() => {
                  const data = { value: item.id, label: item.descripcion };
                  deleteValorForm(item.id);
                  setList([...list, data]);
                }}
                className={classes.chip}
              />
            ))
          ) : (
            <Typography style={{ color: '#777', fontWeight: 'lighter' }}>
              {noChip}
            </Typography>
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export const MultiSearchValidatorGeneric = ({
  dataBody,
  formList,
  setearValorForm,
  deleteValorForm,
  titleChip,
  chipLabel,
  noChip,
  endpoint,
  searchProps,
}) => {
  const classes = useStyles();
  const componentRef = useRef();

  const [value, setValue] = useState(null);
  const [list, setList] = useState(formList);

  const insertValue = () => {
    const data = [...list, dataBody(value)];
    setearValorForm(data);
    setList(data);
    setValue(null);
  };

  return (
    <Grid
      container
      spacing={1}
      style={{ padding: '1em' }}
      component={Paper}
      elevation={2}
      justify="center"
      alignItems="center"
    >
      <Grid item xs={12}>
        <Paper elevation={2} style={{ padding: '1em' }}>
          <Grid container direction="column" spacing={2}>
            <Grid item xs={12}>
              <Buscador
                ref={componentRef}
                value={value}
                setValue={(val) => setValue(val)}
                filterOptions={(results) =>
                  results.filter((item) => !list.some((l) => l.id === item.id))
                }
                endpoint={(inputValue) => endpoint(inputValue)}
                {...searchProps}
              />
            </Grid>
            <Grid item xs={12} style={buttonStyle}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={insertValue}
                disabled={!value}
              >
                + AGREGAR
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          marginTop: '1em',
        }}
      >
        <Typography variant="button">{titleChip}</Typography>
        <div className={classes.root}>
          {formList.length > 0 ? (
            formList.map((item, index) => (
              <Chip
                key={index}
                label={chipLabel(item)}
                onDelete={() => {
                  deleteValorForm(item.id);
                  setList(list.filter((l) => l.id !== item.id));
                }}
                className={classes.chip}
              />
            ))
          ) : (
            <Typography style={{ color: '#777', fontWeight: 'lighter' }}>
              {noChip}
            </Typography>
          )}
        </div>
      </Grid>
    </Grid>
  );
};
